<template>
  <button
    :class="['custom-button', {
      'custom-button--loading': loading,
      'custom-button--disabled': disabled
    }]"
    :disabled="disabled"
    @click="handleClick"
  >
    <span v-if="loading" class="custom-button__spinner">
      <svg viewBox="0 0 24 24" width="20" height="20">
        <circle
          cx="12"
          cy="12"
          r="10"
          fill="none"
          stroke-width="2"
          stroke="currentColor"
        />
      </svg>
    </span>
    <span v-else class="custom-button__text">{{ text }}</span>
  </button>
</template>

<script>
export default {
  name: 'CustomButton',
  props: {
    text: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick() {
      if (!this.loading && !this.disabled) {
        this.$emit('click');
      }
    }
  }
};
</script>

<style scoped>
.custom-button {
  width: 100%;
  padding: 1rem;
  background-color: #6772e5;
  color: white;
  font-weight: 600;
  font-size: 1.125rem;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  overflow: hidden;
}

.custom-button:hover:not(:disabled) {
  background-color: #5469d4;
  transform: translateY(-1px);
}

.custom-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.custom-button__text {
  transition: opacity 0.2s ease;
}

.custom-button__spinner {
  width: 20px;
  height: 20px;
  animation: spin 1s linear infinite;
}

.custom-button--loading .custom-button__text {
  opacity: 0;
}

.custom-button--loading .custom-button__spinner circle {
  stroke-dasharray: 62.832;
  stroke-dashoffset: 62.832;
  animation: dash 1.5s ease-in-out infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dashoffset: 62.832;
  }
  50% {
    stroke-dashoffset: 15.708;
  }
  100% {
    stroke-dashoffset: 62.832;
  }
}
</style>
